import { stockImageFromId } from 'main/util/school'
import * as React from 'react'

import { SchoolPage_school } from '../gql'
import { Container, SchoolName, Tagline } from './Hero.styles'

interface IProps {
  school: SchoolPage_school
}

export default function Hero(props: IProps) {
  const { school } = props
  const { profile } = school

  return (
    <Container imageUrl={getImageUrl(school.id)}>
      <SchoolName>{school.name}</SchoolName>
      {profile && profile.tagline && <Tagline>{profile.tagline}</Tagline>}
    </Container>
  )

  function getImageUrl(schoolId: number) {
    const profileMedia = profile && profile.primaryProfileMedia[0]
    if (!profileMedia) {
      const randomImage = stockImageFromId(schoolId)
      return `${randomImage}/-/format/auto/-/scale_crop/1800x680/smart/`
    }

    return `${profileMedia.media.url}-/format/auto/-/scale_crop/1800x680/smart/`
  }
}
